import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';

// Utils

import { internationalizeList } from '@utils/miscellaneous/internationalizeList';



const MandatorySeekingForCoverageModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        environment: {
            isState,
            links: {
                DASHBOARD
            }
        },
        modalHeaderProps,
        modalHeaderProps: {
            modalId
        }
    } = props;
    const stateRequiresModalHeader = isState.NM;
    const headerProps = {
        ...modalHeaderProps,
        modalHeaderTextData: modalHeaderProps.modalHeaderTextData(stateRequiresModalHeader),
        hideModal: hideAllModals,
    };

    const handleDashboardClick = () => {
        window.location = DASHBOARD;
    };

    const handleHideClick = () => hideAllModals();

    const getParagraphs = () => {

        const ids = [
            'modals.mandatory_seeking_for_coverage.at_least_one',
            {
                id: 'modals.mandatory_seeking_for_coverage.click_close',
                replacements: { strong: chunks => <strong>{chunks}</strong> },
                dataTestid: `${modalId}-click_close`
            },
            {
                id: 'modals.mandatory_seeking_for_coverage.click_dashboard',
                replacements: { strong: chunks => <strong>{chunks}</strong> },
                dataTestid: `${modalId}-click_dashboard`
            },
        ];

        return internationalizeList(ids, 'p');

    };

    return (
        <Fragment>
            <ModalHeader
                {...headerProps}
                closeAllModals
                hideAllModals={hideAllModals}
            />
            <div className="gi-modal__body txt-left" id = 'mandatorySeekingForCoverageModal'>
                { getParagraphs() }
            </div>
            <div className="gi-modal__controls">
                <Button
                    className="usa-button usa-button--outline gi-button gi-button__outline"
                    data-testid={`${modalId}-close_btn`}
                    onClick={handleHideClick}
                >
                    <FormattedMessage id='button.close'/>
                </Button>
                <Button
                    className="usa-button gi-button gi-button__primary"
                    data-testid={`${modalId}-dashboard_btn`}
                    onClick={handleDashboardClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.dashboard'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default MandatorySeekingForCoverageModal;
